import { Formik } from 'formik';
import { CreateEmailScheduleData } from 'bloggers-backend/lib/emailScheduler/domain';
import { Form } from '../../components/forms/Form';
import ButtonWithLoading from '../../components/forms/SubmitButton';
import { useCreateForm } from '../../components/forms/hooks/useCreateForm';
import { EmailAccountPicker } from './components/EmailAccountPicker';

export default function CreateEmailSchedulerPage() {
  const { isSubmitLoading, create, validate } = useCreateForm<CreateEmailScheduleData>(
    'emailScheduler',
    '/email-schedulers',
  );

  return (
    <Formik
      initialValues={{
        account: { id: '', email: '' },
      } as CreateEmailScheduleData}
      onSubmit={create}
      validate={validate}
    >
      <Form>
        <h2>Create an email scheduler:</h2>
        <EmailAccountPicker name="account" />

        <ButtonWithLoading loading={isSubmitLoading} />
      </Form>
    </Formik>
  );
}
